import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyNaviStrikeGroup({}) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={
        "Carrier Strike Group Four / NAVSUP Global Logistics Support / U.S. Navy"
      }
      subtitle={"VoIP Communications for Designated Naval Vessels"}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Executive Summary</NtCaseStudyTextBold>
        {"\n\n"}NT Connect Holdings, Inc., founded in 2018, is a leading
        provider of SIP VoIP and IT solutions, specializing in secure, scalable,
        and mission-critical communications networks. Responding to NAVSUP
        Global Logistics Support’s RFQ, NT Connect was selected to provide
        advanced VoIP phone services supporting Carrier Strike Group Four
        (CSG-4) at Joint Expeditionary Base Little Creek.{"\n\n"}CSG-4 is a
        pivotal U.S. Navy command responsible for training, certifying, and
        readying Atlantic Fleet carrier strike groups, amphibious ready groups,
        and independently deploying surface ships. The command’s
        mission-critical communication needs demand highly reliable, secure, and
        redundant voice services across the designated vessels TSV-1 Prevail,
        TSV-3 Hunter, TSV-4 Narragansett, and TSV-5 Vindicator.{"\n\n"}
        <NtCaseStudyTextBold>Challenge</NtCaseStudyTextBold>
        {"\n\n"}CSG-4 required a solution to deliver dual VoIP SIP lines with
        high availability and cybersecurity compliance, rapid deployment within
        a 90-day timeframe, and 24/7 remote support. The communications
        infrastructure needed to ensure operational continuity during demanding
        training and deployment cycles involving integrated warfare exercises
        and multinational interoperability.{"\n\n"}{" "}
        <NtCaseStudyTextBold>Solution</NtCaseStudyTextBold>
        {"\n\n"}NT Connect delivered a turnkey solution with:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>High-availability SIP lines</NtCaseStudyTextBold>{" "}
        on each vessel to guarantee failover and uninterrupted voice
        communication.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Strict adherence to federal cybersecurity standards
        </NtCaseStudyTextBold>
        , including NIST SP 800-171, to protect mission-critical data.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Minimized downtime and risks</NtCaseStudyTextBold>{" "}
        by leveraging dual-line failover and continuous technical support.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Scalable solution architecture
        </NtCaseStudyTextBold>{" "}
        designed to evolve with future communication requirements.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Impact</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Enhanced operational readiness
        </NtCaseStudyTextBold>{" "}
        for Carrier Strike Group Four, enabling seamless voice communications
        during complex, integrated warfare training and real-world deployments.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Improved interoperability</NtCaseStudyTextBold>{" "}
        with joint and coalition forces through reliable and secure
        communication channels.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Minimized downtime and risks</NtCaseStudyTextBold>{" "}
        by leveraging dual-line failover and continuous technical support
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Scalable solution architecture
        </NtCaseStudyTextBold>{" "}
        designed to evolve with future communication requirements.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Why NT Connect?</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Proven Experience:</NtCaseStudyTextBold> Successful
        past performance with the U.S. Navy and premier maritime clients such as
        the Canadian Coast Guard and major cruise lines.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Specialized Expertise:</NtCaseStudyTextBold> Deep
        knowledge in SIP/VoIP technologies, satellite connectivity, and
        mission-critical communication networks.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Trusted Partner:</NtCaseStudyTextBold> A dedicated
        small business committed to supporting defense communications with
        innovative, secure, and reliable solutions.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          About Carrier Strike Group Four
        </NtCaseStudyTextBold>
        {"\n\n"}
        Headquartered at Naval Station Norfolk, Virginia, CSG-4 leads training
        and certification efforts for Atlantic Fleet carrier strike groups and
        amphibious ready groups. The command focuses on integrated warfare,
        assessment, and the development of training requirements, conducting
        multi-week exercises like COMPTUEX and TFEX to ensure readiness for
        global naval operations.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyNaviStrikeGroup;
